import { Assignment, Business, ContactMail, ExposureTwoTone, HideImage, Inventory, People, Person, PhotoLibrary, Timeline, TrendingDown, TrendingUp } from "@mui/icons-material";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import DrawIcon from "@mui/icons-material/Draw";

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const PALETTE = [
    '#0a2540', '#1a6b5e', '#f59e0b', '#3b82f6', '#8b5cf6', '#ec4899', 
    '#0d9488', '#4f46e5', '#2563eb', '#db2777', '#ea580c', '#16a34a',
    '#0284c7', '#7c3aed', '#b91c1c', '#475569', '#65a30d', '#d97706',
    '#0891b2', '#9333ea', '#c026d3', '#dc2626', '#14b8a6', '#6366f1',
    '#f43f5e', '#a855f7', '#10b981', '#f97316', '#06b6d4', '#34d399',
    '#fb7185', '#64748b'
];

export const FILTER_BAR_OPTIONS = {
  regions: ["North", "South", "West", "East", "Central"],
  states: ["Delhi", "Punjab", "Karnataka", "Tamil Nadu", "Gujarat", "West Bengal", "Maharashtra"],
  roles: ["IC", "BSP", "DSP", "BD", "Sales Enabler", "Dealer", "Studio"],
  prices: ["G2", "G3", "G5", "Others"],
  years: ["2022-2023","2023-2024", "2024-2025", "2025-2026", "2026-2027"],
};

export const adminCountsData = {
  "monthLogin": [
    {
      "month": "January",
      "roleDistribution": {
        "BSP": 26,
        "IC": 61,
        "BD": 15,
        "DSP": 5,
        "Studio": 5,
        "Dealer": 26,
        "Sales Enabler": 8
      }
    },
    {
      "month": "February",
      "roleDistribution": {
        "BSP": 26,
        "BD": 16,
        "Studio": 3,
        "Dealer": 35,
        "IC": 74,
        "DSP": 3,
        "Sales Enabler": 8
      }
    },
    {
      "month": "March",
      "roleDistribution": {
        "IC": 72,
        "BD": 13,
        "Dealer": 39,
        "Studio": 4,
        "DSP": 4,
        "BSP": 25,
        "Sales Enabler": 4
      }
    },
    {
      "month": "April",
      "roleDistribution": {
        "IC": 74,
        "Dealer": 24,
        "BSP": 14,
        "Sales Enabler": 6,
        "BD": 13,
        "Studio": 4,
        "DSP": 3
      }
    },
    {
      "month": "May",
      "roleDistribution": {
        "IC": 70,
        "Sales Enabler": 5,
        "Dealer": 29,
        "BD": 13,
        "DSP": 4,
        "BSP": 21,
        "Studio": 4
      }
    },
    {
      "month": "June",
      "roleDistribution": {
        "Sales Enabler": 2,
        "IC": 2
      }
    },
    {
      "month": "July",
      "roleDistribution": []
    },
    {
      "month": "August",
      "roleDistribution": []
    },
    {
      "month": "September",
      "roleDistribution": []
    },
    {
      "month": "October",
      "roleDistribution": []
    },
    {
      "month": "November",
      "roleDistribution": []
    },
    {
      "month": "December",
      "roleDistribution": []
    }
  ],
  "userProjects": [
    {
      "month": "January",
      "roleDistribution": {
        "BD": 119,
        "BSP": 246,
        "Dealer": 28,
        "DSP": 35,
        "IC": 302,
        "Sales Enabler": 13,
        "Studio": 60
      }
    },
    {
      "month": "February",
      "roleDistribution": {
        "BD": 115,
        "BSP": 189,
        "Dealer": 65,
        "DSP": 35,
        "IC": 391,
        "Sales Enabler": 10,
        "Studio": 52
      }
    },
    {
      "month": "March",
      "roleDistribution": {
        "BD": 61,
        "BSP": 173,
        "Dealer": 104,
        "DSP": 41,
        "IC": 298,
        "Sales Enabler": 28,
        "Studio": 53
      }
    },
    {
      "month": "April",
      "roleDistribution": {
        "BD": 93,
        "BSP": 140,
        "Dealer": 67,
        "DSP": 45,
        "IC": 356,
        "Sales Enabler": 9,
        "Studio": 64
      }
    },
    {
      "month": "May",
      "roleDistribution": {
        "BD": 61,
        "BSP": 148,
        "Dealer": 56,
        "DSP": 32,
        "IC": 309,
        "Sales Enabler": 37,
        "Studio": 31
      }
    },
    {
      "month": "June",
      "roleDistribution": {
        "IC": 2,
        "Sales Enabler": 8
      }
    },
    {
      "month": "July",
      "roleDistribution": {}
    },
    {
      "month": "August",
      "roleDistribution": {}
    },
    {
      "month": "September",
      "roleDistribution": {}
    },
    {
      "month": "October",
      "roleDistribution": {}
    },
    {
      "month": "November",
      "roleDistribution": {}
    },
    {
      "month": "December",
      "roleDistribution": {}
    }
  ],
  "stateQuotation": [
    {
      "state": "ANDHRA PRADESH",
      "total": 466,
      "roleDistribution": {
        "BSP": 224,
        "DSP": 153,
        "IC": 89
      }
    },
    {
      "state": "BANGALORE",
      "total": 39,
      "roleDistribution": {
        "BD": 39
      }
    },
    {
      "state": "BANGLORE",
      "total": 197,
      "roleDistribution": {
        "BD": 14,
        "BSP": 72,
        "Dealer": 6,
        "IC": 83,
        "Studio": 22
      }
    },
    {
      "state": "BIHAR",
      "total": 64,
      "roleDistribution": {
        "BD": 15,
        "Dealer": 6,
        "DSP": 8,
        "IC": 35
      }
    },
    {
      "state": "CHENNAI",
      "total": 19,
      "roleDistribution": {
        "BD": 16,
        "Dealer": 3
      }
    },
    {
      "state": "CHHATTISGARH",
      "total": 22,
      "roleDistribution": {
        "DSP": 22
      }
    },
    {
      "state": "DELHI & NCR",
      "total": 413,
      "roleDistribution": {
        "BD": 248,
        "BSP": 4,
        "Dealer": 18,
        "IC": 63,
        "Sales Enabler": 25,
        "Studio": 55
      }
    },
    {
      "state": "EASTERN UP",
      "total": 68,
      "roleDistribution": {
        "IC": 68
      }
    },
    {
      "state": "GOA",
      "total": 2,
      "roleDistribution": {
        "Dealer": 2
      }
    },
    {
      "state": "GUJARAT",
      "total": 411,
      "roleDistribution": {
        "BD": 8,
        "BSP": 39,
        "Dealer": 26,
        "IC": 259,
        "Sales Enabler": 79
      }
    },
    {
      "state": "HARYANA",
      "total": 85,
      "roleDistribution": {
        "Dealer": 2,
        "IC": 83
      }
    },
    {
      "state": "JAMMU & KASHMIR",
      "total": 54,
      "roleDistribution": {
        "Dealer": 13,
        "IC": 41
      }
    },
    {
      "state": "JHARKHAND",
      "total": 4,
      "roleDistribution": {
        "Studio": 4
      }
    },
    {
      "state": "KERALA",
      "total": 94,
      "roleDistribution": {
        "BD": 4,
        "BSP": 22,
        "Dealer": 14,
        "IC": 54
      }
    },
    {
      "state": "MADHYA PRADESH",
      "total": 10,
      "roleDistribution": {
        "BSP": 4,
        "Dealer": 1,
        "IC": 5
      }
    },
    {
      "state": "MUMBAI",
      "total": 53,
      "roleDistribution": {
        "BD": 16,
        "Dealer": 1,
        "IC": 36
      }
    },
    {
      "state": "NORTH EAST",
      "total": 26,
      "roleDistribution": {
        "Dealer": 13,
        "IC": 13
      }
    },
    {
      "state": "ODISHA",
      "total": 30,
      "roleDistribution": {
        "IC": 30
      }
    },
    {
      "state": "PUNJAB & CHANDIGARH",
      "total": 184,
      "roleDistribution": {
        "BD": 12,
        "BSP": 1,
        "Dealer": 4,
        "IC": 167
      }
    },
    {
      "state": "RAJASTHAN",
      "total": 302,
      "roleDistribution": {
        "BSP": 282,
        "Dealer": 9,
        "IC": 10,
        "Sales Enabler": 1
      }
    },
    {
      "state": "ROK",
      "total": 274,
      "roleDistribution": {
        "BSP": 64,
        "Dealer": 80,
        "IC": 130
      }
    },
    {
      "state": "ROM",
      "total": 547,
      "roleDistribution": {
        "BD": 48,
        "BSP": 3,
        "Dealer": 64,
        "DSP": 5,
        "IC": 248,
        "Studio": 179
      }
    },
    {
      "state": "ROTN",
      "total": 180,
      "roleDistribution": {
        "BSP": 24,
        "Dealer": 20,
        "IC": 136
      }
    },
    {
      "state": "South 1",
      "total": 24,
      "roleDistribution": {
        "BSP": 24
      }
    },
    {
      "state": "TELANGANA",
      "total": 19,
      "roleDistribution": {
        "BD": 5,
        "Dealer": 7,
        "IC": 7
      }
    },
    {
      "state": "UTK&UP",
      "total": 8,
      "roleDistribution": {
        "BSP": 8
      }
    },
    {
      "state": "UTTARAKHAND",
      "total": 129,
      "roleDistribution": {
        "BSP": 85,
        "Dealer": 7,
        "IC": 37
      }
    },
    {
      "state": "WEST BENGAL",
      "total": 45,
      "roleDistribution": {
        "BD": 7,
        "BSP": 3,
        "Dealer": 4,
        "IC": 31
      }
    },
    {
      "state": "WESTERN UP",
      "total": 107,
      "roleDistribution": {
        "BD": 17,
        "BSP": 37,
        "Dealer": 20,
        "IC": 33
      }
    }
  ]
}

const roleColors = {
  // 3 Primary Business Anchors (Solid, distinct blocks)
  IC: "#0f3b63",              // Deep Corporate Navy
  BD: "#0d9488",              // Sharp Emerald Teal
  DSP: "#f59e0b",             // Premium Amber

  // 2 Light Structural Tints (Instantly recognizable contrast)
  BSP: "#38bdf8",             // Clean Sky Blue
  'Sales Enabler': "#99f6e4", // Light Mint Teal

  // 2 Definitive Matte Neutrals (Grounds the chart cleanly)
  Dealer: "#1e293b",          // Dark Matte Slate
  Studio: "#64748b"           // Balanced Steel Gray
};

export const monthlyLogins = {
  labels: adminCountsData?.monthLogin?.map(item => item.month) || [],
  datasets: Object.keys(adminCountsData?.monthLogin?.[0]?.roleDistribution || {}).map(role => ({
    label: role.toUpperCase(),
    data: adminCountsData?.monthLogin?.map(item => item.roleDistribution[role] || 0) || [],
    backgroundColor: roleColors[role] || "#94a3b8",
    stack: "combined",
  }))
};

export const monthlyUserQuotes = {
  labels: adminCountsData?.userProjects?.map(item => item.month) || [],
  datasets: Object.keys(adminCountsData?.userProjects?.[0]?.roleDistribution || {}).map(role => ({
    label: role.toUpperCase(),
    data: adminCountsData?.userProjects?.map(item => item.roleDistribution[role] || 0) || [],
    backgroundColor: roleColors[role] || "#94a3b8",
    stack: "combined",
  }))
};
export const stateQuotes = {
  labels: adminCountsData?.stateQuotation?.map(item => item.state) || [],
  datasets: Object.keys(adminCountsData?.stateQuotation?.[0]?.roleDistribution || {}).map(role => ({
    label: role.toUpperCase(),
    data: adminCountsData?.stateQuotation?.map(item => item.roleDistribution[role] || 0) || [],
    backgroundColor: roleColors[role] || "#94a3b8",
    stack: "combined",
  }))
};